/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { WebsitesService } from '@app/settings/websites/websites.service';
import { WebsitesFormService } from '@app/settings/websites/websites-form.service';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { Website } from '@app/settings/websites/website.model';
import { environment } from '@env/environment';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { AccessService } from '@app/core/access/access.service';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';

const log = new Logger('WebsitesListComponent');

@Component({
  selector: 'app-websites-list',
  templateUrl: './websites-list.component.html',
  styleUrls: ['./websites-list.component.scss'],
})
export class WebsitesListComponent extends KendoGridComponent implements OnInit {
  websitesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;

  UserRoleType = UserRoleType;

  constructor(
    private websitesService: WebsitesService,
    private websitesFormService: WebsitesFormService,
    protected kendoGridService: KendoGridService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('WebsitesListComponent');
    this.loadData(this.state);
  }

  /**
   * Open Websites form
   */
  add(): void {
    this.websitesFormService.open().then(() => {
      this.loadData();
    });
  }

  /**
   *  Отваря Website form и подава website обекта
   * @param website Website
   */
  edit(website: Website): void {
    this.websitesFormService.open(website).then(() => {
      this.loadData(this.state);
    });
  }

  /**
   * Изтрива Website
   * @param website Website
   */
  delete(website: Website): void {
    this.websitesService.destroy(website.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  /**
   * Зарежда данните от API-то
   * @param state State
   */
  loadData(state: DataStateChangeEvent = null): void {
    this.state = state;
    this.apiQuery.setDataSetFilters(state).addIncludes('company');

    this.websitesService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.websitesResponse = response;
      log.debug(response.data);
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('WebsitesListComponent', this.state);
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
